import styles from './newsletter-archive.module.scss';

const NewsletterArchive = ({ isGelderland }: { isGelderland?: boolean }): React.JSX.Element => {
	if (isGelderland) {
		return (
			<>
				<NewsletterIframe
					title="Archief"
					url="https://nieuwsbrieven.gelderland.nl/x/plugin/?pName=overall_mailing_archive&MIDRID=S7Y1AAAA00&pLang=nl&Z=-302650001"
				/>
			</>
		);
	} else {
		return (
			<NewsletterIframe
				title="Blik op Oost"
				url="https://nieuwsbrieven.gelderland.nl/x/plugin/?pName=mailing_archive&MIDRID=S7Y1BQAA46&pLang=nl&Z=-419495052"
			/>
		);
	}
};

const NewsletterIframe = ({ title, url }: { title: string; url: string }): React.JSX.Element => {
	return (
		<>
			<h2 className={styles.header}>{title}</h2>
			<iframe className={styles.newsletterArchive} src={url}></iframe>
		</>
	);
};

export default NewsletterArchive;
